import memoize from 'lodash/memoize';

/**
 * Prepares the tree for application usage after receiving it from the Location SDK. Function return value is memoized.
 * @param payload
 * @returns {Object}
 */
export default memoize(payload => {
  if (!payload) {
    return payload;
  }
  const nodesDictionary = {};
  let rootId;

  payload.map(node => {
    if (nodesDictionary[node.id]) {
      nodesDictionary[node.id].name = node.name;
      nodesDictionary[node.id].original = node;
    } else {
      nodesDictionary[node.id] = {
        id: node.id,
        name: node.name,
        original: node
      };
    }

    if (!node.parentId) {
      rootId = node.id;
    }

    // push the node to parent's children
    else {
      if (nodesDictionary[node.parentId]) {
        if (!nodesDictionary[node.parentId].children) {
          nodesDictionary[node.parentId].children = [];
        }
        nodesDictionary[node.parentId].children[node.order] = nodesDictionary[node.id];
      } else {
        // If parent doesn't exist - create one
        nodesDictionary[node.parentId] = {
          id: node.parentId,
          children: []
        };
        nodesDictionary[node.parentId].children[node.order] = nodesDictionary[node.id];
      }
    }
  });

  Object.keys(nodesDictionary).forEach(k => {
    if (nodesDictionary[k].children) {
      nodesDictionary[k].children = nodesDictionary[k].children.filter(n => n);
    }
  });

  return {
    tree: rootId ? nodesDictionary[rootId] : undefined,
    nodesDictionary
  };
});
